<template>
  <div>
    <el-upload
      :class="imageUrl ? 'showImage' : ''"
      :limit="1"
      :action="uploadURL"
      :data="getData"
      :headers="headers"
      list-type="picture-card"
      :show-file-list="false"
      :on-error="handleAvatarError"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <img
        v-if="imageUrl"
        :src="imageUrl"
        class="avatar"
        alt=""
      />
      <div
        v-else
        style="display: flex;flex-direction: column;align-items: center;justify-content: center;height: 100%;"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
        <span
          style="line-height: 20px;margin-top: 4px;color: #A9ACB7">{{ describe }}</span>
      </div>
    </el-upload>
    <div style="margin-top: 10px">支持jpg、png格式，文件大小不得超过1M。</div>
  </div>
</template>

<script>
import baseUrl from "../api/baseUrl";
export default {
  data () {
    return {
      imageUrl: "",
      uploadURL: baseUrl + '/api/v1/file/upload',
      headers: {
        token: sessionStorage.getItem('token')
      },
    }
  },
  props: {
    describe: String,
    type: Number,
    label: String,
    url: String,
  },
  watch: {
    "url": {
      handler (newV) {
        if (newV) this.imageUrl = baseUrl + this.url;
      }
    }
  },
  computed: {
    getData () {
      return {
        type: this.type,
      }
    }
  },
  methods: {
    handleAvatarError (res, file) {
    },
    // 上传成功
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$emit("send", this.label, res.data.id);
    },
    // 上传之前
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!');
      }
      return isJPG && isLt2M;
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-upload {
  background: #d4d4d7;
  width: 280px;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.showImage {
  /deep/.el-upload {
    background: #fff;
  }
}
</style>
